<template>
  <form action="https://www.paypal.com/cgi-bin/webscr" id="frmpayment" method="post" name="frmpayment">
    <!--  https://developer.paypal.com/docs/paypal-payments-standard/integration-guide/html-example-subscribe/#basic-subscribe-button -->
    <input name="business" type="hidden" value="paypal@jikatel.com">

    <!-- Specify a Subscribe button. -->
    <input type="hidden" name="cmd" value="_xclick-subscriptions">

    <input name="item_name" type="hidden" :value="packageName">
    <input name="item_number" type="hidden" value="">

    <!-- Set the terms of the regular subscription. -->
    <input type="hidden" name="currency_code" value="USD">
    <input type="hidden" name="a3" :value="amt">
    <input type="hidden" name="p3" value="1">
    <input type="hidden" name="t3" value="M">

    <!-- Set recurring payments until canceled. -->
    <input type="hidden" name="src" value="1">

    <!-- Display the payment button. -->
    <!--<input type="image" name="submit" src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribe_LG.gif" alt="Subscribe">
    <img alt="" width="1" height="1" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" >-->

    <input name="cancel_return" type="hidden" :value="cancelUrl">
    <input name="return" type="hidden" :value="successUrl">
    <input name="custom" type="hidden" :value="customData">
  </form>
</template>

<script>
export default {
  props: {
    packageName: {
      required: true
    },
    amt: {
      required: true
    },
    customData: {
      required: true
    },
  },
  data () {
    return {
      successUrl: process.env.VUE_APP_MAIN_FRONTEND_DOMAIN + '/home/renewal-successful-payment',
      cancelUrl:  process.env.VUE_APP_MAIN_FRONTEND_DOMAIN + '/home',
    }
  },
  mounted() {
    //console.log('this.baseBackendDomain', this.baseBackendDomain)
    document.getElementById('frmpayment').submit();
  }
}
</script>
